import type { Niche } from '@fluenceur/types';

// ---------------------------------------------------------------------------
// Persona bank — 8 fictional creators, one per portrait asset
// ---------------------------------------------------------------------------

export type PersonaKey = 'lena' | 'hugo' | 'noah' | 'maya' | 'ines' | 'camille' | 'sacha' | 'chloe';

export interface ExamplePersona {
  key: PersonaKey;
  displayName: string;
  username: string;
  profilePictureUrl: string;
  /** i18n key suffix under companion.wizard.ready.examples.<key> */
  briefKey: PersonaKey;
}

export const EXAMPLE_PERSONAS: Record<PersonaKey, ExamplePersona> = {
  lena: {
    key: 'lena',
    displayName: 'Léna Carvalho',
    username: 'lena.glow',
    profilePictureUrl: '/images/companion/companion-creator-1.webp',
    briefKey: 'lena',
  },
  hugo: {
    key: 'hugo',
    displayName: 'Hugo Marchand',
    username: 'hugo.encuisine',
    profilePictureUrl: '/images/companion/companion-creator-2.webp',
    briefKey: 'hugo',
  },
  noah: {
    key: 'noah',
    displayName: 'Noah Diallo',
    username: 'noah.fitcheck',
    profilePictureUrl: '/images/companion/companion-creator-3.webp',
    briefKey: 'noah',
  },
  maya: {
    key: 'maya',
    displayName: 'Maya Lopes',
    username: 'maya.slowliving',
    profilePictureUrl: '/images/companion/companion-creator-4.webp',
    briefKey: 'maya',
  },
  ines: {
    key: 'ines',
    displayName: 'Inès Robert',
    username: 'ines.enmouvement',
    profilePictureUrl: '/images/companion/companion-creator-5.webp',
    briefKey: 'ines',
  },
  camille: {
    key: 'camille',
    displayName: 'Camille Aubert',
    username: 'camille.dressing',
    profilePictureUrl: '/images/companion/companion-creator-6.webp',
    briefKey: 'camille',
  },
  sacha: {
    key: 'sacha',
    displayName: 'Sacha Nguyen',
    username: 'sacha.connecte',
    profilePictureUrl: '/images/companion/companion-creator-7.webp',
    briefKey: 'sacha',
  },
  chloe: {
    key: 'chloe',
    displayName: 'Chloé Bernard',
    username: 'chloe.interieurs',
    profilePictureUrl: '/images/companion/companion-creator-8.webp',
    briefKey: 'chloe',
  },
};

// ---------------------------------------------------------------------------
// Niche → persona mapping
// ---------------------------------------------------------------------------

export const NICHE_TO_PERSONA: Record<Niche, PersonaKey> = {
  mode_fashion: 'camille',
  beaute_beauty: 'lena',
  food_cuisine: 'hugo',
  voyage_travel: 'noah',
  fitness_sport: 'ines',
  lifestyle: 'noah',
  famille_parenting: 'chloe',
  tech_gaming: 'sacha',
  humour_comedy: 'noah',
  business_entrepreneuriat: 'sacha',
  art_culture: 'chloe',
  musique_music: 'noah',
  education_science: 'sacha',
  decoration_home: 'chloe',
  finance_money: 'sacha',
  sante_wellness: 'maya',
  automobile: 'sacha',
  photographie: 'camille',
  animaux_pets: 'chloe',
  other: 'maya',
};

// ---------------------------------------------------------------------------
// Follower count buckets — deterministic, no Math.random
// ---------------------------------------------------------------------------

export const FOLLOWERS_BY_SIZE: Record<
  'nano' | 'micro' | 'mid' | 'macro',
  [number, number, number]
> = {
  nano: [6800, 8900, 4700],
  micro: [18400, 32600, 56200],
  mid: [142000, 263000, 387000],
  macro: [684000, 1120000, 905000],
};
